var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3695 0C30.1291 0 34 4.0426 34 10.0589V23.9428C34 29.9591 30.1291 34 24.3678 34H9.6322C3.8709 34 0 29.9591 0 23.9428V10.0589C0 4.0426 3.8709 0 9.6322 0H24.3695ZM11.6297 12.5783C9.1919 12.5783 7.208 14.5622 7.208 17C7.208 19.4395 9.1919 21.4234 11.6297 21.4234C13.6221 21.4234 15.2915 20.0906 15.8423 18.275H19.4327V20.1484C19.4327 20.8522 20.0039 21.4234 20.7077 21.4234C21.4115 21.4234 21.9827 20.8522 21.9827 20.1484V18.275H24.2437V20.1484C24.2437 20.8522 24.8149 21.4234 25.5187 21.4234C26.2225 21.4234 26.7937 20.8522 26.7937 20.1484V17C26.7937 16.2962 26.2225 15.725 25.5187 15.725H15.8423C15.2915 13.9111 13.6221 12.5783 11.6297 12.5783ZM11.6299 15.1281C12.6618 15.1281 13.5033 15.9679 13.5033 17.0015C13.5033 18.0334 12.6618 18.8732 11.6299 18.8732C10.598 18.8732 9.75647 18.0334 9.75647 17.0015C9.75647 15.9679 10.598 15.1281 11.6299 15.1281Z",
    fill: "#122A46"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/PasswordIcon.a405b2947d406938c65c51053e74147a.svg";
export { ForwardRef as ReactComponent };